import { Moment } from "moment-timezone";
import CalendarScheduleSlotModel from "./CalendarScheduleSlotModel";
import SessionModel from "../api/models/SessionModel";
import { StudentResponseType } from "../api/@types/apiResponseTypes";
import StudentModel from "../api/models/StudentModel";

export type ScheduledSessionType = {
  startTime: Moment;
  endTime: Moment;
  sessionNumber: number;
  sessionType: string;
  slotDBId: number;
  sessionId?: string | null;
  sessionStatus?: string | null;
  student?: StudentResponseType;
};

const UPCOMING_NEXT_SESSION_BUFFER_IN_MINUTES = 5;
export default class ScheduledSession {
  startTime: Moment;
  endTime: Moment;
  sessionNumber: number;
  sessionType: string;
  slotDBId: number;
  sessionId?: string | null;
  sessionStatus?: string | null;
  student?: StudentResponseType;

  constructor(arg: ScheduledSessionType) {
    this.startTime = arg.startTime;
    this.endTime = arg.endTime;
    this.sessionNumber = arg.sessionNumber;
    this.sessionType = arg.sessionType;
    this.sessionId = arg.sessionId;
    this.sessionStatus = arg.sessionStatus;
    this.student = arg.student;
    this.slotDBId = arg.slotDBId;
  }

  get generatedId(): string {
    return `${this.startTime}_${this.endTime}`;
  }

  toSessionModel(): SessionModel {
    const sessionApi = {
      id: this.generatedId,
      slot_id: this.slotDBId,
      date: this.startTime,
      start_time: this.startTime,
      end_time: this.endTime,
      session_number: this.sessionNumber,
      status: this?.sessionStatus ?? "unknown",
    };
    const session = SessionModel.fromApiResponse(sessionApi) as SessionModel;
    session.student = StudentModel.fromApiResponse(
      this.student
    ) as StudentModel;
    return session;
  }

  isUpcomingNext(referenceDateTime: Moment): boolean {
    return (
      this.startTime.isAfter(referenceDateTime) && // The start time is after the current time
      this.startTime.isSameOrBefore(
        referenceDateTime
          .clone()
          .add(UPCOMING_NEXT_SESSION_BUFFER_IN_MINUTES, "minutes")
      ) // The start time is 5 minutes or less ahead of current time
    );
  }

  isInProgress(referenceDateTime: Moment): boolean {
    return (
      referenceDateTime.isSameOrAfter(this.startTime) &&
      referenceDateTime.isBefore(this.endTime)
    );
  }
}
